export default __webpack_public_path__ + "static/media/1000x200Banner1.ba7f656a.jpeg";